import { useState, useEffect, useRef } from 'react';

interface StreamingModeProps {
  streamUrl: string;
}

function StreamingMode({ streamUrl }: StreamingModeProps) {
  const [hasError, setHasError] = useState(false);
  const [actualUrl, setActualUrl] = useState<string | null>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  // Quando cambia URL, aggiungi cache-buster per forzare nuova connessione
  useEffect(() => {
    console.log('[StreamingMode] URL changed to:', streamUrl);
    setHasError(false);

    // Pulisci prima la vecchia connessione
    if (imgRef.current) {
      imgRef.current.src = '';
    }

    // Piccolo delay per permettere al browser di chiudere la connessione
    const timer = setTimeout(() => {
      const separator = streamUrl.includes('?') ? '&' : '?';
      const urlWithCacheBuster = `${streamUrl}${separator}_t=${Date.now()}`;
      console.log('[StreamingMode] Setting URL with cache-buster:', urlWithCacheBuster);
      setActualUrl(urlWithCacheBuster);
    }, 100);

    return () => clearTimeout(timer);
  }, [streamUrl]);

  // Cleanup: quando il componente si smonta, rimuovi la src per chiudere la connessione MJPEG
  useEffect(() => {
    return () => {
      console.log('[StreamingMode] Unmounting, cleaning up stream connection');
      if (imgRef.current) {
        imgRef.current.src = '';
      }
    };
  }, []);

  // Se c'è errore, URL non disponibile, o stiamo aspettando il delay, mostra solo nero
  if (hasError || !streamUrl || !actualUrl) {
    return <div className="h-screen w-screen bg-black" />;
  }

  return (
    <div className="h-screen w-screen bg-black flex items-center justify-center">
      <img
        ref={imgRef}
        src={actualUrl}
        alt=""
        className="max-w-full max-h-full object-contain"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
        onError={() => {
          console.log('[StreamingMode] Error loading stream from:', actualUrl);
          setHasError(true);
        }}
      />
    </div>
  );
}

export default StreamingMode;
